export default function NewsletterLoading({ text }: { text: string }) {
  return (
    <div
      role="status"
      className="mt-6 inline-flex min-h-[6.4rem] items-center gap-4 rounded-full border border-current/20 px-6 py-4"
    >
      <span
        aria-hidden="true"
        className="size-7 shrink-0 animate-spin rounded-full border-2 border-current/20 border-t-current motion-reduce:animate-none"
      />
      <span className="text-[1.8rem]">{text}</span>
    </div>
  );
}
